export const TELEGRAM_BOT_URL = 'https://t.me/Jhon_sportbot'

export function formatPercent(value: number | null | undefined, decimals = 0): string {
  if (value == null) return '—'
  return `${(value * 100).toFixed(decimals)}%`
}

export function formatMoney(value: number, currency = 'EUR'): string {
  return new Intl.NumberFormat('es-ES', { style: 'currency', currency, maximumFractionDigits: 2 }).format(value)
}
